import { render } from "./UserRegisterInfoView.vue?vue&type=template&id=0b47a88f&ts=true"
import script from "./UserRegisterInfoView.vue?vue&type=script&lang=ts"
export * from "./UserRegisterInfoView.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Dmes\\webdds-src\\frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__